import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Edit from './edit';
import Save from './save';

registerBlockType( 'create-block/accordionquestion', {
	title: __( 'Accordion Question', 'ask-faq' ),
	description: __( 'A accordion question item', 'ask-faq' ),
	icon: 'welcome-add-page',
	parent: [ 'create-block/askfaq' ],
	supports: {
		reusable: false,
		html: false,
	},
	attributes: {
		accordionQuestion: {
			type: "string",
			default: ""
		},
		accordionAnswer: {
			type: 'string',
			default: '',
		},
		accordionVideoAnswer: {
			type: 'string',
			default: '',
		},
		accordionAudioAnswer: {
			type: 'string',
			default: '',
		},
		accordionAnswerType: {
			type: 'string',
			default: 'text',
		},
		name: {
			type: 'string',
			source: 'html',
			selector: 'h4',
		},
		url: {
			type: 'string',
			source: 'attribute',
			selector: 'img',
			attribute: 'src',
		},
	},
	edit: Edit,
	save: Save,
} );
